/**
 * @file 单独渲染截图字段
 * @author yinfangyan
 */
export default {
    isImgType(state) {
        let imgSrc = '';
        let isImg = false;
        if (state.topicData.topicInfo.extBeanList.length) {
            isImg = state.topicData.topicInfo.extBeanList.some(item => {
                if (item.name === '截图') {
                    imgSrc = item.value;
                    return true;
                }
            });
        }
        if (isImg) {
            let img = imgSrc.replace(/[\[\]"////]/g,'').split(',');
            return img;
        }
        return [];
    }
};
